import { ROOT_SLUG } from "../../../const/enviroment";
import { ReactNode } from "react";
import { CategoryType } from "../../../types/Category.ts";
import { useCategoryParent } from "../../../fetch/fetch.category.ts";
import { EMPTY_CATEGORY } from "../../../const/typeDefault/Category.ts";

const ParentCategoryList = ({
  slug,
  children,
  showRoot,
}: {
  slug: string;
  children: (category: CategoryType) => ReactNode;
  showRoot: boolean;
}) => {
  const { category, isLoading, isError } = useCategoryParent(slug, EMPTY_CATEGORY);

  const isRoot = (maybeSlug: string) => maybeSlug === ROOT_SLUG;

  // Root has no parent; the current category is rendered by the caller (breadcrumbs).
  if (isRoot(slug)) return null;

  // While loading (or when the request fails), avoid recursing with the fallback category (slug: "").
  if (isLoading || isError || !category.slug) return null;

  // Stop at root (optionally include it) and guard against cycles.
  if (isRoot(category.slug)) return showRoot ? children(category) : null;
  if (category.slug === slug) return null;

  return (
    <>
      <ParentCategoryList slug={category.slug} showRoot={showRoot}>
        {children}
      </ParentCategoryList>
      {children(category)}
    </>
  );
};
export default ParentCategoryList;
